import React from 'preact/compat';
interface Props {
  message?: string;
}
export const LoadingCart: React.FC<Props> = ({
  message = 'Please wait...',
}) => {
  return (
    <div
      class={'loading-cart'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '20px',
        width: '100%',
        height: '50%',
      }}
    >
      <svg
        style={{ color: '#000' }}
        version="1.1"
        id="L3"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={'100px'}
        viewBox="0 0 100 100"
        enable-background="new 0 0 0 0"
        aria-hidden={true}
      >
        <circle
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          cx="50"
          cy="50"
          r="44"
          style="opacity:0.5;"
        />
        <circle
          fill="currentColor"
          stroke="currentColor"
          stroke-width="3"
          cx="8"
          cy="54"
          r="6"
        >
          <animateTransform
            attributeName="transform"
            dur="2s"
            type="rotate"
            from="0 50 48"
            to="360 50 52"
            repeatCount="indefinite"
          />
        </circle>
      </svg>

      <h5>{message}</h5>
    </div>
  );
};
